import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState, MyThunkDispatch } from 'store';

import { fetchHasAccess } from 'actions/accessLog';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { CostCenter } from 'models/costCenter';
import CostCenterSelectList from 'screens/components/CostCenterList';
import { getCostCenters, saveCostCenter } from 'services/costCenterService';

const CostCenterListContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const [costCenterList, setCostCenterList] = useState<CostCenter[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);
  const adminId = useSelector((state: RootState) => (state.user.accountResult ? state.user.accountResult?.id : ''));

  const tourLoading = useSelector((state: RootState) => state.accessLog.isLoading);
  const hasAccess = useSelector((state: RootState) => state.accessLog.ListCostCenter);
  const [totalCostCenters, setTotalCostCenters] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const screenName = 'ListCostCenter';
    dispatch(fetchHasAccess(screenName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]);

  const MAX_ITEMS_PER_PAGE = 10;
  const getData = async (page?: number, query?: string, status?: string) => {
    setLoading(true);

    try {
      const res = await getCostCenters(companyId, query, MAX_ITEMS_PER_PAGE, page ?? 1, status === 'active' ? true : false, status === 'inactive' ? true : false);

      console.log(res);

      setCurrentPage(page ?? 1);

      if (res.data.totalResults === 0) {
        setTotalCostCenters(0);
        setCostCenterList([]);
        setLoading(false);
        return;
      }

      setTotalCostCenters(res.data.totalResults);
      setCostCenterList(res.data.result);
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('costCenter.costCenterAggregation.errorFetch'),
      });
      setLoading(false);
    }
    setLoading(false);
  };

  const handleToggleCostCenter = async (costCenter: CostCenter) => {
    try {
      setSaving(true);
      const saved = await saveCostCenter({ ...costCenter, isActive: !costCenter.isActive });
      if (saved) {
        getData();
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('costCenterList.errorToggle'),
      });
    } finally {
      setSaving(false);
    }
  };
  return (
    <CostCenterSelectList
      costCenterList={costCenterList}
      isLoading={isLoading}
      isSaving={isSaving}
      tourHasAccess={hasAccess}
      tourLoading={tourLoading}
      onToggleCostCenter={handleToggleCostCenter}
      loadCostCenters={getData}
      totalCostCenters={totalCostCenters}
      currentPage={currentPage}
      maxItemsPerPage={MAX_ITEMS_PER_PAGE}
    />
  );
};

export default CostCenterListContainer;
